module.exports = __webpack_public_path__ + "img/espaycrow-logo-white.67ee5e04.png";